import { render } from "./WhatsappCtas.vue?vue&type=template&id=674a144e&scoped=true"
import script from "./WhatsappCtas.vue?vue&type=script&lang=ts"
export * from "./WhatsappCtas.vue?vue&type=script&lang=ts"

import "./WhatsappCtas.vue?vue&type=style&index=0&id=674a144e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-674a144e"

export default script